(function(EF) {

  var Customization = Backbone.Model.extend({
    initialize: function(attributes, options) {
        this.enrollment = options.enrollment;
    },
    url: function() {
        return EF.url('/sdk/enrollments/' + this.enrollment.get('id') +'/customizations/' + this.get('type') + '.json');
    },
    getBySlug: function(slug) {
      if(this.get('customizations')) {
        return _.find(this.get('customizations'), { slug: slug });
      }
    },
    getByPage(moduleKey, activityKey, pageKey) {
      if(this.get('customizations')) {
        return this.get('customizations').reduce((results, c) => {
          if(c.module_key === moduleKey && c[activityKey] && c[activityKey][pageKey]) {
            const checked_content = (typeof c[activityKey][pageKey] === 'object') ? c[activityKey][pageKey].content : c[activityKey][pageKey];
            results.push({
              content_type: c.content_type,
              content: c[activityKey][pageKey] === 'module_default' ? c.module_default : checked_content,
              custom_id: (typeof c[activityKey][pageKey] === 'object') ? c[activityKey][pageKey].custom_id : ''
            });
          }
          return results;
        }, []);
      }
    }
  });

  _.extend(EF.Models, {
    Customization: Customization
  });

}(EF));
